
import {  gsap, Power3 } from "gsap";
import { GameData } from "../../../server/data/GameData";
import { GameSetting } from "../../../../core/setting/GameSetting";
import { ArrayHelper } from "../../../../core/utils/ArrayHelper";
import { SoundManager } from "../../../config/sound/SoundManager";
import { SanEngineManager } from '../../../engine/SanEngineManager';
import { SanQuentin2 } from "../../../SanQuentin2";
import { SanEngineController } from "../../../engine/SanEngineController";
import { RevealerManager } from "../../../modules/revealer/RevealerManager";
import { ReavealerState, Revealer } from "../../../modules/revealer/Revealer";
import { ScatterRevealPresentation } from "../../features/scatter/ScatterRevealPresentation";
import { StopPresentation } from "../Normal/StopPresentation";

export class FSStopPresentation extends StopPresentation {

    protected get basicStopDelay():number[]{

        let delay:number[] = this._gameData.Win.allBetWayWinData.longest > 2 ? [0, 0.4, 0.7, 0.9, 1.1] : [0, 0.4, 0.7, 0.8, 0.9];

        if(this._gameData.raw.numJumpingWilds >= 3) 
            delay.forEach((v,i) => {delay[i] *=1.2;} );

        if(SanEngineManager.isQuickStop || GameSetting.isFastSpin){
            delay = [0,0,0,0,0];
        }
        if(this._gameData.Win.BoomWin){
            delay[3] = 1.5;
            delay[4] = 2.5;
        }

        return  delay;
    }
  
    setGameData(data: GameData): void {
        super.setGameData(data);
        this.countScatter = 0;
        this.scatterPos = data.Reel.scatterPositions;
        this.ammScatterLanded = 0;

        if(this.possibleWin.length > 2){
            ArrayHelper.eachForEach(this.possibleWin,(reel,row) => {
                if(this.possibleWin[reel][row] && !data.Win.allBetWayWinData.reelWinPositions[reel][row]) this.possibleWin[reel][row] = false;
            })

            if( !this.possibleWin[0].find(() => true) || !this.possibleWin[1].find(() => true) )
                this.possibleWin = [];
        }
        SanEngineManager.parseData(data.Reel);
    }

    preStart(): void {
        super.preStart();
        RevealerManager.setSpecialData(this._gameData.Reel.convictedMysterySymbol,this._gameData.Reel.convictedMysteryMultiplier);
    }

    // Add Start Offset.
    protected addStartReelOffset(): boolean {
        const remaining: number = SanEngineManager.remainingStartEngineOffset();
        this.timeline.to(this, { duration: remaining }, 0);
        return !!remaining;
    }

    protected onStop(rc: SanEngineController): void { 
        this.barOnStop(rc);
    }

    protected onBounce(rc: SanEngineController): void { 
        super.onBounce(rc);

        rc.AllWindowSymbols.forEach(sym => {
            if(this._gameData.Reel.convictedMysterySymbol === sym.symName)
                sym.isSpecial(this._gameData.Reel.convictedMysteryMultiplier,0.25);
        })
    }

    protected onPreWinMarked(rc: SanEngineController):void{
        if(rc.reelID < 2 || !this.nearWinMap[0].find(v => v)) return;
        if(rc.reelID == 2){
            for(let k = 0; k <= rc.reelID; k++){
                SanEngineManager.AllReels[k].AllWindowSymbols.forEach(sym =>{
                    if(!this.nearWinMap[k][sym.posID[0]] && !sym.isScatter){
                        sym.markNonWin(true,0.45,0.3);
                    }
                })
            }
        }else{
            rc.AllWindowSymbols.forEach(sym =>{
                if(!this.nearWinMap[rc.reelID][sym.posID[0]] && !sym.isScatter){
                    sym.markNonWin(true,0.45,0.3);
                }
            })
        }
    }

    protected barOnStop(rc: SanEngineController){
        if(!this._gameData.Reel.raw.topBottomReelOpened[rc.reelID]){
            this.barAnim(rc);
        }
    }

    protected onStopped(rc: SanEngineController): void {
        if(this._gameData.Win.BoomWin && rc.reelID == 2){
            SanQuentin2.BorderFire.IgniteFire();
        }

        const animTime:number = this.animationTl.totalTime();
        SanQuentin2.jumpingWildController.getJWOnReel(rc.reelID).forEach( jw => {
            if(jw.visible){
                jw.onSpinStop(rc.engine.timeLeft);
                // this.animationTl.add(() => jw.onSpinStop(rc.engine.timeLeft),animTime);
            }
        })

        if(this._gameData.Reel.StopBarsOnStop[rc.reelID] || RevealerManager.getTopBar(rc.reelID).isActive){
            const topBar = RevealerManager.getTopBar(rc.reelID);
            const botBar =  RevealerManager.getBotBar(rc.reelID);
            
            this.playFeaturePerBar(topBar);
            this.playFeaturePerBar(botBar);
        }
    }

    protected playFeaturePerBar(rev:Revealer):void{
        const start = this.animationTl.totalTime();
        if(rev.state.equal(ReavealerState.SPLITTER)){
            this.animationTl.add(() => { rev.glowMult() },start)
            this.animationTl.add( ScatterRevealPresentation.doReelSplit(rev,rev.ID), start);
        }
    }
}